import { cloneDeep } from 'lodash'

export const formatForUpload = (field: APICustomField) => {
  const toUpload = { ...field }

  if (!toUpload.archived_at) {
    toUpload.archived_at = null
  }

  if (!toUpload.config) {
    toUpload.config = null
  } else {
    if (!toUpload.config.id || toUpload.config.id === 'null') {
      delete toUpload.config.id
    }
    if (!toUpload.config.options || toUpload.config.options.length === 0) {
      delete toUpload.config.options
    } else {
      toUpload.config.options = removeEmptyFields(toUpload.config.options)
      toUpload.config.options = removeEmptyStrings(toUpload.config.options)
    }
  }

  if (toUpload.description === '') {
    toUpload.description = null
  }

  delete toUpload.created_by
  delete toUpload.created_at
  delete toUpload.updated_at
  delete toUpload.options

  return toUpload
}

function removeEmptyFields (obj) {
  const toUpdate = cloneDeep(obj)
  return toUpdate.reduce((acc, item) => {
    const newItemConditions = item.conditions.filter(x => x.field_id !== '')
    const newItem = { ...item, conditions: newItemConditions }
    acc.push(newItem)
    return acc
  }, [])
}

function removeEmptyStrings (obj) {
  if (Array.isArray(obj)) {
    return obj
      .filter(item => typeof item !== 'string' || item.trim() !== '')
      .map(item => (typeof item === 'object' ? removeEmptyStrings(item) : item))
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (typeof value !== 'string' || value.trim() !== '') {
        acc[key] = typeof value === 'object' ? removeEmptyStrings(value) : value
      }
      return acc
    }, {})
  }
  return obj
}
